import React, { useEffect, useState } from "react";
import useGlobal from "../../../util/Global";
import useQuery from "../../../util/useQuery";
import CepTelConfirm from "../../Ebasvuru/Adaylar/CepTelConfirm";
import Accountservice from "../../../service/Core/AccountService";
import TokenKodlariservice from "../../../service/Ebasvuru/TokenKodlariService";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import { useCookies } from "react-cookie";
import Ilanlar from "../../Ebasvuru/Adaylar/Ilanlar";


const AdayLogin = () => {

    const { t } = useGlobal();
    //const [adayState, setStateAday] = useState(null);
    const { setAday } = useCookies();
    const [login, setLogin] = useState(null);
    const [pageTipi, setPageTipi] = useState('ilanlar');

    const query = useQuery();
    const tenantKey = query.get('tenant');
    const kanalId = query.get('id');

    //const { params } = useParams();

    useEffect(() => {
        if (tenantKey) {
            const res = Accountservice.loginAsAday(
                {
                    tenant: tenantKey
                }).then((res) => {
                    if (res && res.token) {
                        EbasvuruTenantservice.setToken(res.token);
                        setLogin(res);
                    }
                });
        }

    }, [tenantKey]);


    const onAdaySubmit = async (data) => {

        const res = await Accountservice.loginAsAday(
            {
                tenant: tenantKey
            });

        if (res && res.aday != null) {



            const code = await TokenKodlariservice.getSMSToken();


            setAday(res.aday);
            setPageTipi("Confirm");

        } else {
            setPageTipi("Register");
        }
        console.log("Submitted Data:", data);
    };

    const Register = () => {
        return (<></>);
    }

    const AdayConfirm = () => {
        return (<></>);
    }

    const renderPage = () => {
        switch (pageTipi) {
            case "ilanlar":
                return <Ilanlar login={login} />
            case "Login":
                return <CepTelConfirm onSubmit={onAdaySubmit} />;
            case "Register":
                return <Register />;
            case "Confirm":
                return <AdayConfirm />;
            default:
                return <></>;
        }
    };

    return renderPage();
};

export default AdayLogin;
